module.exports = __webpack_public_path__ + "static/media/block-separator.42fc8c56.svg";